import { animate, style, transition, trigger } from '@angular/animations';
import { Platform } from '@angular/cdk/platform';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppService } from 'src/app/app.service';
import { CardCenterService } from 'src/app/pages/card-center/card-center.service';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { NavMenuItem, NavType } from 'src/app/shared/interfaces/settings.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { PopupService } from 'src/app/shared/service/popup.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { SendbirdChatService } from '../sendbird-chat/sendbird-chat.service';

@UntilDestroy()
@Component({
  selector: 'app-bottom-menu',
  templateUrl: './bottom-menu.component.html',
  styleUrls: ['./bottom-menu.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('0.2s ease-in-out', style({ transform: 'translateY(0)' })),
      ]),
      transition(':leave', [animate('0.2s ease-in-out', style({ transform: 'translateY(100%)' }))]),
    ]),
    trigger('inOut', [
      transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('0s', style({ transform: 'translateY(0)' })),
      ]),
      transition(':leave', [animate('0s', style({ transform: 'translateY(100%)' }))]),
    ]),
  ],
})
export class BottomMenuComponent implements OnInit {
  isH5!: boolean;
  active: boolean = true;
  loggedIn!: boolean;
  hasNotification!: boolean;
  hasBonus!: boolean;
  tooltipOpen: boolean = false;
  menuActive: boolean = false;
  chatActive: boolean = false;
  currentUrl: string = '';
  isSportOpen: boolean = true;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // 如果 tooltip 開啟，檢查點擊目標是否在 Sports 按鈕或 tooltip 內
    if (this.tooltipOpen) {
      const sportsButton = document.querySelector('[class*="bottom-menu"] .menu-item:has(.fi-basketball-filled)');
      const tooltip = document.querySelector('.tooltip');

      // 如果點擊既不在按鈕也不在 tooltip 內，則關閉
      if (sportsButton && tooltip) {
        const isClickInsideButton = sportsButton.contains(event.target as Node);
        const isClickInsideTooltip = tooltip.contains(event.target as Node);

        if (!isClickInsideButton && !isClickInsideTooltip) {
          this.tooltipOpen = false;
        }
      }
    }
  }

  constructor(
    public layout: LayoutService,
    private popup: PopupService,
    private appService: AppService,
    private localeService: LocaleService,
    private platform: Platform,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private cardCenterService: CardCenterService,
    private sendbirdChatService: SendbirdChatService,
    private toast: ToastService,
    private localStorageService: LocalStorageService,
  ) {}

  get toolsData(): NavMenuItem[] {
    return [
      { id: 1, name: this.localeService.getValue('menu'), icon: 'fi-menu', page: null, navType: NavType.Menu },
      // {
      //   id: 2,
      //   name: this.localeService.getValue('bottom_menu_bonus'),
      //   icon: 'icon-bottom-activity',
      //   page: null,
      //   navType: NavType.Bonus,
      // },
      // {
      //   id: 3,
      //   name: this.localeService.getValue('bottom_menu_notification'),
      //   icon: 'icon-bell',
      //   page: this.loggedIn
      //     ? `/${this.appService.languageCode}/notification-center/home`
      //     : `/${this.appService.languageCode}/register`,
      //   navType: NavType.Notification,
      // },
      // {
      //   id: 4,
      //   name: this.localeService.getValue('h5_cs'),
      //   icon: 'icon-kefu',
      //   page: null,
      //   navType: NavType.CustomerService,
      // },
      // {
      //   id: 5,
      //   name: this.localeService.getValue('wallet'),
      //   icon: 'icon-wallet3',
      //   page: `/${this.appService.languageCode}/wallet`,
      //   navType: NavType.Wallet,
      // },
      {
        id: 6,
        name: this.localeService.getValue('Casino'),
        icon: 'fi-casino-filled',
        page: `/${this.appService.languageCode}/home`,
        navType: NavType.Casino,
      },
      //體育入口要顯示，點擊彈tooltip說明敬請期待
      {
        id: 7,
        name: this.localeService.getValue('sports'),
        icon: 'fi-basketball-filled',
        page: `/${this.appService.languageCode}/play/SoftswissSport-1/All`,
        // page: null,
        navType: NavType.Sports,
      },
      // {
      //   id: 7,
      //   name: this.localeService.getValue('live_text'),
      //   icon: 'fi-live-casino-filled',
      //   page: `/${this.appService.languageCode}/${this.appService.tenantConfig$.value?.config?.liveCasinoUrl as string}`,
      //   navType: NavType.LiveCasino,
      // },
      { id: 8, name: 'Chat', icon: 'fi-chat-alt-2', page: null, navType: NavType.Chat },
    ];
  }

  originalHeight = 0;
  androidHandle = () => {
    const tagName = document.activeElement?.tagName;
    const curHeight = document.documentElement.clientHeight || document.body.clientHeight;
    if (curHeight > this.originalHeight && (tagName === 'INPUT' || tagName === 'TEXTAREA')) {
      //android软键盘弹出
      this.active = false;
      this.layout.setH5BottomMenuActive(this.active);
      this.layout.h5Keyboard$.next(true);
    } else if (!this.active) {
      //android软键盘收起
      this.active = true;
      this.layout.setH5BottomMenuActive(this.active);
      this.layout.h5Keyboard$.next(false);
    }
  };
  iosFocusinHandle = () => {
    const tagName = document.activeElement?.tagName;
    if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
      // ios软键盘弹起
      this.active = false;
      this.layout.setH5BottomMenuActive(this.active);
      this.layout.h5Keyboard$.next(true);
    } else if (!this.active) {
      // 不是真的输入框（软键盘已收起），重置
      this.active = true;
      this.layout.setH5BottomMenuActive(this.active);
      this.layout.h5Keyboard$.next(false);
    }
  };
  iosFocusoutHandle = () => {
    if (!this.active) {
      // 软键盘已收起，重置
      this.active = true;
      this.layout.setH5BottomMenuActive(this.active);
      this.layout.h5Keyboard$.next(false);
    }
  };

  ngOnInit() {
    this.layout.setH5BottomMenuActive(this.active);

    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe((v: AccountInforData | null) => {
      this.loggedIn = !!v;
    });

    this.appService.noticeCounts$.pipe(untilDestroyed(this)).subscribe(e => {
      this.hasNotification = !!e?.All;
    });

    this.cardCenterService.bounsCount$.pipe(untilDestroyed(this)).subscribe(bounsCount => {
      this.hasBonus = !!bounsCount;
    });

    // 訂閱左側選單狀態
    this.layout.leftMenuState$.pipe(untilDestroyed(this)).subscribe(isOpen => {
      this.menuActive = isOpen;
    });

    // 訂閱 Chat 開啟狀態
    this.sendbirdChatService.displayChat$.pipe(untilDestroyed(this)).subscribe(isOpen => {
      this.chatActive = isOpen;
    });

    // 訂閱路由變化
    this.router.events.pipe(untilDestroyed(this)).subscribe(() => {
      this.currentUrl = this.router.url;
    });
    this.currentUrl = this.router.url;

    // 订阅是否h5
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => {
      document.body.removeEventListener('focusin', this.iosFocusinHandle);
      document.body.removeEventListener('focusout', this.iosFocusoutHandle);
      window.removeEventListener('resize', this.androidHandle);
      this.isH5 = e;
      const isMobile = this.deviceService.isMobile();
      // h5模式且是移动设备时候才生效
      if (e && isMobile) {
        if (this.platform.IOS) {
          document.body.addEventListener('focusin', this.iosFocusinHandle);
          document.body.addEventListener('focusout', this.iosFocusoutHandle);
        } else {
          this.originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
          window.addEventListener('resize', this.androidHandle);
        }
      } else {
        this.active = true;
        this.layout.setH5BottomMenuActive(this.active);
        this.layout.h5Keyboard$.next(false);
      }
    });
  }

  handleClick(item: NavMenuItem) {
    // 如果點擊的是有 page 的按鈕（Casino 等），且左側選單或 Chat 開啟，則關閉它們
    if (item.page && (this.menuActive || this.chatActive)) {
      this.layout.leftMenuState$.next(false);
      this.sendbirdChatService.hideChat();
    }

    switch (item.navType) {
      case NavType.Menu: {
        const currentLeftMenuState = this.layout.leftMenuState$.getValue();
        this.layout.leftMenuState$.next(!currentLeftMenuState);
        this.sendbirdChatService.hideChat();
        break;
      }

      case NavType.Bonus:
        this.loggedIn
          ? this.router.navigate([this.appService.languageCode, 'promotions'], {
              queryParams: {
                go: 'couponCenter',
              },
            })
          : this.router.navigate([this.appService.languageCode, 'promotions', 'offer']);
        break;

      case NavType.CustomerService:
        this.appService.toOnLineService$.next(true);
        break;
      case NavType.Chat:
        if (!this.localStorageService.loginToken) {
          this.layout.leftMenuState$.next(false);
          this.appService.jumpToRegister();
          break;
        }

        this.layout.leftMenuState$.next(false);
        this.sendbirdChatService.toggleChat();
        break;
      case NavType.Sports:
        // 簡單切換 tooltip 的開啟/關閉狀態
        this.tooltipOpen = !this.tooltipOpen;
        break;
      default:
        break;
    }
  }

  getActiveState(item: NavMenuItem): boolean {
    // Menu 按鈕：當左側選單開啟時為 active
    if (item.id === 1) {
      return this.menuActive;
    }

    // Chat 按鈕：當 Chat 開啟時為 active
    if (item.id === 8) {
      return this.chatActive;
    }

    // 其他有 page 的按鈕：只有在選單和 Chat 都關閉且路由匹配時才 active
    if (item.page && !this.menuActive && !this.chatActive) {
      // console.log(this.currentUrl, item.page);
      return this.currentUrl.includes(item.page);
    }

    return false;
  }

  getIconClass(item: NavMenuItem): string {
    // Menu 按鈕：active 時顯示 fi-x，否則顯示原本的 icon
    // if (item.id === 1) {
    //   return this.menuActive ? 'fi-x' : item.icon;
    // }

    // // Chat 按鈕：active 時顯示 fi-x，否則顯示原本的 icon
    // if (item.id === 8) {
    //   return this.chatActive ? 'fi-x' : item.icon;
    // }

    // 其他按鈕直接返回原本的 icon
    return item.icon;
  }
}
